import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { ButtonDirective, MaterialIconComponent } from '@ps-gui/shared-core';

@Component({
  selector: 'shared-ui-add-button',
  imports: [ButtonDirective, MaterialIconComponent],
  templateUrl: './add-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddButtonComponent {
  readonly disabled = input(false);
  clicked = output();
}
